export default "__VITE_ASSET__e4dfe27b__"